import loadable from "@loadable/component";
const TradeInCarDetails = loadable(() => import("../au.desktop/components/trade-in-car-details"));
const TradeInPreConditions = loadable(() => import("../au.desktop/components/trade-in-preconditions"));
const TradeInEstimatedValuation = loadable(() => import("../au.desktop/components/trade-in-estimated-valuation"));
const TradeInExteriorCondition = loadable(() => import("../au.desktop/components/trade-in-exterior-condition"));
const TradeInMechanicalCondition = loadable(() => import("../au.desktop/components/trade-in-mechanical-condition"));
const TradeInInteriorCondition = loadable(() => import("../au.desktop/components/trade-in-interior-condition"));
const TradeInValuation = loadable(() => import("../au.desktop/components/trade-in-valuation"));
const TradeInSorryScreen = loadable(() => import("../au.desktop/components/trade-in-sorry-screen"));

export const c2bTradeRoutes = {
    tradeInCarDetails: {
        key: "tradeInCarDetails",
        name: "Select Car",
        description: "Select your car model",
        route: "car-details",
        defaultNext: "pre-conditions",
        defaultBack: "",
        component: TradeInCarDetails,
        hideCurrentPill: false,
        isOptionalRoute: false,
        validateRoute: true,
        type: "tradein",
        approx: 2
    },
    tradeInPreConditions: {
        key: "tradeInPreConditions",
        name: "Preconditions",
        route: "pre-conditions",
        description: "Service history, rust, keys & major issues",
        gtmPageName: "",
        gtmPillClickLabel: "",
        defaultNext: "estimated-valuation",
        defaultBack: "car-details",
        component: TradeInPreConditions,
        hideCurrentPill: false,
        isOptionalRoute: false,
        validateRoute: true,
        type: "tradein",
        approx: 2
    },
    tradeInEstimatedValuation: {
        key: "tradeInEstimatedValuation",
        name: "Estimated valuation",
        route: "estimated-valuation",
        description: "Get an estimated range",
        gtmPageName: "",
        gtmPillClickLabel: "",
        defaultNext: "exterior-condition",
        defaultBack: "pre-conditions",
        component: TradeInEstimatedValuation,
        hideCurrentPill: false,
        isOptionalRoute: true,
        validateRoute: true,
        type: "tradein",
        approx: 2
    },
    tradeInExteriorCondition: {
        key: "tradeInExteriorCondition",
        name: "Exterior condition",
        description: "Panels, lights, wing mirrors & tyre condition",
        route: "exterior-condition",
        defaultNext: "mechanical-condition",
        defaultBack: "estimated-valuation",
        component: TradeInExteriorCondition,
        hideCurrentPill: false,
        isOptionalRoute: false,
        validateRoute: true,
        type: "checkout",
        approx: 2
    },
    tradeInMechanicalCondition: {
        key: "tradeInMechanicalCondition",
        name: "Mechanical condition",
        description: "Dashboard warning lights",
        route: "mechanical-condition",
        defaultNext: "interior-condition",
        defaultBack: "exterior-condition",
        component: TradeInMechanicalCondition,
        hideCurrentPill: false,
        isOptionalRoute: false,
        validateRoute: true,
        type: "tradein",
        approx: 2
    },
    tradeInInteriorCondition: {
        key: "tradeInInteriorCondition",
        name: "Interior condition",
        description: "Seats and electronic components",
        route: "interior-condition",
        defaultNext: "valuation",
        defaultBack: "mechanical-condition",
        component: TradeInInteriorCondition,
        hideCurrentPill: false,
        isOptionalRoute: false,
        validateRoute: true,
        type: "tradein",
        approx: 2
    },
    tradeInValuation: {
        key: "tradeInValuation",
        name: "trade-in",
        description: "",
        route: "valuation",
        defaultNext: "confirmation",
        defaultBack: "car-details",
        component: TradeInValuation,
        hideCurrentPill: true,
        isOptionalRoute: false,
        validateRoute: true,
        type: "tradein",
        approx: 2
    },
    errorScreen: {
        key: "errorScreen",
        name: "trade-in",
        route: "error-screen",
        component: TradeInSorryScreen,
        hideCurrentPill: true,
        isOptionalRoute: true
    },
    sorryScreen: {
        key: "sorryScreen",
        name: "trade-in",
        route: "sorry-screen",
        component: TradeInSorryScreen,
        hideCurrentPill: true,
        isOptionalRoute: true
    }
};

export const c2bTradeRoutesArray = Object.values(c2bTradeRoutes);
export const tradeInRoutes = c2bTradeRoutesArray.filter((routeData) => routeData.subType === "trade-in")
    .map((routeData) => routeData.route);
